export default {"src":"/assessments/student/_next/static/media/c.fdabdb1e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};